

define(['angular', 'squid/index', './directive'], function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('hermes.page.xo-generic-message.route', ['squid', 'hermes.page.xo-generic-message.directive']).factory('$GenericMessageRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('GenericMessageRoute', {
      name: 'genericMessage',
      directive: 'xo-generic-message-page',
      titleContent: 'genericError.pleaseTryAgain',
      query: ['code', 'returnUrl'],
      // need to find these values
      trackingData: {},
      children: []
    });
  });
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-generic-message/route.js
// module id = ./pages/xo-generic-message/route.js
// module chunks = 0